import {StoreType} from '../../../types/sharedTypes';

export const allCtnSelector = (state: StoreType) => {
  return state.ctnReducer.ctnResult;
}
